import React from "react"
import ImageGallery from "react-image-gallery";
import styles from "./photoGallery.module.scss"
import "../../node_modules/react-image-gallery/styles/scss/image-gallery.scss";





const PhotoGallery = (props) => {
  // console.log('PhotoGallery')
  // console.log('Photo obj: '+ JSON.stringify(props.object))
  let imgURLbase = "https://m1.quebecormedia.com/emp/emp/"
  const photos = props.object.photos.map((aPhoto)=>{
    let thisPhotoFormat = searchForPhotoFormat('JDX-NO-RATIO', aPhoto.photoFormatsS3)
    if ( typeof thisPhotoFormat === 'undefined' ){
      thisPhotoFormat = searchForPhotoFormat( 'original', aPhoto.photoFormatsS3)
    }
    // console.log('thisPhotoFormat: '+ JSON.stringify(thisPhotoFormat))
    let aimConfig = `?impolicy=crop-resize&h=${thisPhotoFormat.h}&w=${thisPhotoFormat.w}&x=${thisPhotoFormat.x}&y=${thisPhotoFormat.y}`
    let originalSize = `&width=800&height=450`
    let x2Size = `&width=1600&height=900 2x`
    let thumbSize = `&width=100&height=80`

    return {
      original: imgURLbase + thisPhotoFormat.fileName + aimConfig + originalSize,
      thumbnail: imgURLbase + thisPhotoFormat.fileName + aimConfig + thumbSize,
      description: aPhoto.description,
      originalAlt: aPhoto.description,
      srcSet: imgURLbase + thisPhotoFormat.fileName + aimConfig + x2Size
    }
  })


  return(
    <div className={styles.container}>
      {/*{JSON.stringify(photos)}*/}
      <ImageGallery showPlayButton={false} useBrowserFullscreen={false} showBullets={true} items={photos} />
    </div>
  )
}

export default PhotoGallery

function searchForPhotoFormat(nameKey, myArray){
  for (var i=0; i < myArray.length; i++) {
    if (myArray[i].photoFormatType === nameKey) {
      return myArray[i];
    }
  }
}